import { render, staticRenderFns } from "./CompanySettingWizard.vue?vue&type=template&id=39ef9f06&"
import script from "./CompanySettingWizard.vue?vue&type=script&lang=js&"
export * from "./CompanySettingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports